module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zn":{"faq_more_text":"查看更多"},"en":{"faq_more_text":"more"}}')
  delete Component.options._Ctor
}
